import { Button, CircularProgress, Box } from '@material-ui/core'
import { useMemo, useState } from 'react'
import ActivityModal from './ActivityModal'
import axios from 'axios'
import Constant, { getCountryTimeZone } from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import ShowHideText from '../ShowHideText/ShowHideText'
import CheckPermission from '../Permissions/CheckPermission'
const momentTz = require('moment-timezone')

const ActivitiesController = ({ children, refId, status, style }) => {
  const [open, setOpen] = useState(false)
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    loadData()
  }

  const loadData = async () => {
    setLoader(true)
    try {
      const response = await axios.get(
        `${Constant.getAPI()}/admin/get-user-activities/${refId}?status=${status}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: localStorage.getItem('countryShortName'),
          },
        }
      )

      if (response.data.success) {
        setList(response.data.data)
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        Constant.getAuthLogout()
      } else {
        Swal.fire({
          title:
            err?.response?.data?.data?.details?.[0]?.message ||
            err?.response?.data?.message ||
            'An error occurred while loading data.',
          icon: 'error',
        })
      }
    } finally {
      setLoader(false)
    }
  }

  const columns = useMemo(() => {
    const baseColumns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          display: false,
        },
      },
      {
        name: 'comment',
        label: 'Comment',
      },
    ]

    if (status === 'true') {
      baseColumns.push({
        name: 'reason',
        label: 'Status Reason',
      })
    } else {
      baseColumns.push({
        name: 'other_data',
        label: 'Other Data',
        options: {
          customBodyRender: (data) => (
            <ShowHideText text={data || '--'} minLength={200} />
          ),
        },
      })
    }

    baseColumns.push(
      {
        name: 'dbo_user',
        label: 'Changed By',
        options: {
          customBodyRender: (user) => {
            return user
              ? `${user.first_name || ''} ${user.last_name || ''} (${user.user_type || ''})`
              : '--'
          },
        },
      },
      {
        name: 'created_at',
        label: 'Time',
        options: {
          customBodyRender: (data) => {
            return momentTz(data)
              .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
              .format('YYYY-MM-DD hh:mm:ss A')
          },
        },
      }
    )

    return baseColumns
  }, [status])

  const options = {
    viewColumns: false,
    filter: false,
    search: false,
    print: false,
    download: false,
    selectableRows: 'none',
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    textLabels: {
      body: {
        noMatch: loader ? 'Loading...' : 'No data found',
        toolTip: 'Sort',
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
    },
  }

  return (
    <CheckPermission permission={'view_user_activities'}>
      <Button variant="outlined" color="primary" onClick={handleOpen} style={style}>
        {children}
      </Button>

      <ActivityModal open={open} onClose={() => setOpen(false)}>
        {loader ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <MUIDataTable
            className="table-responsive"
            data={list}
            columns={columns}
            options={options}
          />
        )}
      </ActivityModal>
    </CheckPermission>
  )
}

export default ActivitiesController
